import Highcharts from 'highcharts';

import { sortColumnsByX } from '../../../chart/ColumnChart';
import { DEFAULT_GROUP } from '../../../constants/common';
import { chartWithGroups } from './showChartFeatures';

export const grandTotal = 'Grand total';

const showGrandTotal = (chart, show) => {
  const categories = chart.userOptions.xAxis.originalCategories;
  const series = chart.userOptions.originalSeries;
  chart.xAxis[0].setCategories(show ? [...categories, 'Grand total'] : categories);
  let newSeries = [];
  if (show) {
    for (let i = 0; i < series.length; i++) {
      const { data, total } = series[i];
      newSeries.push({
        ...series,
        data: [...data, ['Grand total', total]],
      });
    }
  } else {
    newSeries = [...series];
  }
  chart.update({
    series: newSeries,
  });
};

const sortX = (chart, axis, order) => {
  const orderMult = order === 'DESC' ? -1 : 1;
  const originalCategories = [...chart.userOptions.xAxis.originalCategories];
  const categories = Object.fromEntries(
    chart.userOptions.xAxis.originalCategories.map((c) => [c, 0])
  );
  const total = chart.xAxis[0].categories.includes(grandTotal);
  const { typeSorting } = chart.userOptions;
  let result = originalCategories;
  if (axis === 'X') {
    result = originalCategories.sort(sortColumnsByX(order, typeSorting));
  } else if (axis === 'Y') {
    const entries = Object.entries(
      chart.userOptions.originalSeries
        .flatMap((s) => s.data)
        .reduce(
          (c, [x, y]) => ({
            ...c,
            [x]: c[x] + y,
          }),
          categories
        )
    );

    result = entries.sort(([, y1], [, y2]) => (y1 - y2) * orderMult).map(([category]) => category);
  }
  return total ? [...result, grandTotal] : result;
};

export const sortCategories = ({ axis, order, sortingOptions }, group = DEFAULT_GROUP) => {
  const charts = Highcharts.charts.filter((chart) => chartWithGroups(chart, group, 'sort'));
  if (sortingOptions === 'INDEPENDENT') {
    charts.forEach((chart) => {
      const categories = sortX(chart, axis, order);
      chart.xAxis[0].setCategories(categories);

      // после сортировки категорий, необходимо разместить значения серий в таком же порядке как категории
      chart.series.forEach((s) => {
        const seriesData = Object.fromEntries(s.data.map(({ name, y }) => [name, y]));
        const orderedData = categories
          .map((category) => [category, seriesData[category]])
          .filter(([, value]) => value);
        s.update({ data: orderedData });
      });
    });
    // TODO не реализовано
  } else if (sortingOptions === 'DEPENDENT') {
    const categories = sortX(charts[0], axis, order);
    charts.forEach((chart) => chart.xAxis[0].setCategories(categories));
  }
};

export const grandTotalSorting = (chart, sorting, group = DEFAULT_GROUP) => {
  showGrandTotal(chart, chart.userOptions.grandTotal);
  sortCategories(sorting, group);
};

export const calcTotal = (checked, group) => {
  Highcharts.charts
    .filter((chart) => chartWithGroups(chart, group, 'grandTotal'))
    .forEach((chart) => {
      const cartVar = chart;
      cartVar.userOptions.grandTotal = checked;
      showGrandTotal(cartVar, checked);
    });
};
